import { useEffect, useState } from "react";
import { Button, CircularProgress, makeStyles } from "@material-ui/core";
import { TfiSave } from "react-icons/tfi";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { Skeleton } from "@material-ui/lab";
import ParameterPermissionsForm from "./components/ParameterPermissionsForm";

const useStyles = makeStyles((theme) => ({
    saveBtn: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    cardHeader: {
        display: "flex",
        justifyContent: "space-between",
        [theme.breakpoints.up("xs")]: {
            flexDirection: "column",
            alignItems: "start",
            gap: "10px",
        },
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
        },
    },
}));

const validationSchema = Yup.object({
    certificate: Yup.boolean(),
    shippingDays: Yup.boolean(),
});

const WooCommercePluginParameterPermissions = ({
    userinfo,
    language,
    feedsetting,
}) => {
    const classes = useStyles();
    const [parameterPermissions, setParameterPermissions] = useState(null);
    const [refreshParameter, setRefreshParameter] = useState(0);

    useEffect(() => {
        const source = axios.CancelToken.source();

        axios({
            method: "GET",
            url: `${NODE_API_URL}/INTL/fetch-feed-parameters`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            cancelToken: source.token,
        })
            .then((res) => {
                if (res.data.success) {
                    const data = Object.keys(res.data.data).reduce(
                        (acc, key) => {
                            acc[key] = res.data.data[key]?.enabled || false;
                            return acc;
                        },
                        {}
                    );

                    setInitialFormObj(data);
                    setParameterPermissions(res.data.data);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
                if (error?.response?.data?.message) {
                    toast.error(error?.response?.data?.message);
                }
            });

        return () => {
            source.cancel("Component unmounted: cancel pending request");
        };
    }, [refreshParameter]);

    function handleSubmit(values, actions) {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/update-feed-parameters`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: {
                parameterPermissions: values,
            },
        })
            .then((res) => {
                if (res.data.success) {
                    if (res.data.message) {
                        toast.dismiss();
                        toast.success(res.data.message);
                    }
                    setRefreshParameter((prev) => prev + 1);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
                if (error?.response?.data?.message) {
                    if (error?.response?.data?.message) {
                        toast.error(error?.response?.data?.message);
                    }
                }
            })
            .finally(() => {
                actions.setSubmitting(false);
            });
    }

    const [initialFormObj, setInitialFormObj] = useState(null);

    const formik = useFormik({
        initialValues: initialFormObj,
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: handleSubmit,
    });

    if (!feedsetting) {
        return (
            <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
            </>
        );
    }

    return (
        <div className="row">
            <div className="col-12 ccmode-setting-sticky-header">
                <div
                    className={`col-12 px-0 setting-title pb-5 border-bottom ${classes.cardHeader}`}
                >
                    <div className="d-flex flex-column">
                        <span>WooCommerce Plugin PARAMETER PERMISSIONS</span>
                        <span className="small text-capitalize">
                            Control what your customers can see in their WooCommerce Diamond Plugin
                            experience.
                        </span>
                    </div>
                    <div>
                        <Button
                            disabled={formik.isSubmitting}
                            variant="contained"
                            color="primary"
                            className={classes.saveBtn}
                            onClick={formik.submitForm}
                        >
                            <TfiSave className="mr-3" size={13} />
                            {language.SETTING_PASSWORD_SAVE}
                            {formik.isSubmitting && (
                                <CircularProgress
                                    size={16}
                                    className={"ml-3"}
                                />
                            )}
                        </Button>
                    </div>
                </div>
            </div>
            <div className="col-12 pt-4">
                <FormikProvider value={formik}>
                    <Form>
                        {formik?.values ? (
                            <ParameterPermissionsForm
                                parameterPermissions={parameterPermissions}
                            />
                        ) : (
                            ""
                        )}
                    </Form>
                </FormikProvider>
            </div>
        </div>
    );
};

export default WooCommercePluginParameterPermissions;
